export class StringFormatHelper {
  public static toString(value: any): string {
    try {
      return value.toString();
    } catch (e) {
      return '';
    }
  }
}
